import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { } from '../models/Notification';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private readonly http: HttpClient) { }

  GetNotifications(params: any) {
    return this.http.get(`${environment.apiUrl}/Notification/List`, { params });
  }

  SeeNotifications(id: any) {
    return this.http.get(`${environment.apiUrl}/Notification/SeeNotifications?NotificationID=${id}`);
  }
}
